import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PRONTLIFE_WHATSAPP_NUMBER } from "constants/contacts";
import {
  APLICATIVOS_URL,
  HOME_URL,
  OPERADORAS_URL,
  PLANOS_URL,
} from "constants/router";
import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { sendAnalyticEventWhatsapp } from "utils/store-link";
import ProntlifeBranco from "../../assets/logo/Logo_Branca.svg";
import ProntLifeColorida from "../../assets/logo/Logo_Colorida.svg";

export const smoothScroll = (elementId: string) => {
  return document
    .getElementById(elementId)
    ?.scrollIntoView({ behavior: "smooth" });
};

export const TopNavbar = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);
  const LINK_TO_LOGIN = "https://app.prontlife.com.br/prontlife-web/login.html";

  return (
    <nav className="navbar navbar-expand-xl fixed-top navbar-custom-theme">
      <Link to={HOME_URL} className="d-flex navbar-brand" tabIndex={0}>
        <img
          src={ProntlifeBranco}
          alt="logo da empresa"
          className={"d-none d-xl-block"}
          style={{
            width: "200px",
            marginLeft: "20px",
            alignSelf: "flex-start",
          }}
        />
        <img
          src={ProntLifeColorida}
          alt="logo da empresa"
          className={"d-xl-none"}
          style={{ width: "150px", alignSelf: "flex-start" }}
        />
        <span className="text-hide">PronLife</span>
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        onClick={handleNavCollapse}
        aria-expanded={isNavCollapsed}
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon">
          <FontAwesomeIcon
            fixedWidth
            icon={isNavCollapsed ? faBars : faTimes}
            className={"text-primary"}
            style={{ opacity: "70%" }}
            size={"lg"}
          />
        </span>
      </button>
      <div
        className={`${isNavCollapsed ? "collapse " : ""} navbar-collapse`}
        id="navbarNav"
      >
        <ul className="navbar-nav d-flex flex-xl-row justify-content-end ml-auto mr-5">
          <li
            className="nav-item d-none active"
            onClick={handleNavCollapse}
            tabIndex={1}
          >
            <NavLink
              to={HOME_URL}
              exact={true}
              className={"nav-link"}
              activeClassName={"font-weight-bold"}
            >
              Home
            </NavLink>
          </li>
          <li className="nav-item" onClick={handleNavCollapse} tabIndex={2}>
            <NavLink
              to={OPERADORAS_URL}
              className={"nav-link "}
              activeClassName={"font-weight-bold"}
            >
              Operadoras
            </NavLink>
          </li>
          <li className="nav-item" onClick={handleNavCollapse} tabIndex={3}>
            <NavLink
              to={APLICATIVOS_URL}
              className={"nav-link "}
              activeClassName={"font-weight-bold"}
            >
              Pacientes
            </NavLink>
          </li>
          <li className="nav-item" onClick={handleNavCollapse} tabIndex={4}>
            <NavLink
              to={PLANOS_URL}
              className={"nav-link"}
              activeClassName={"font-weight-bold"}
            >
              Planos
            </NavLink>
          </li>
          <li
            className="nav-item"
            onClick={handleNavCollapse}
            tabIndex={5}
            role="button"
          >
            <span
              onClick={() => smoothScroll("contato")}
              className="nav-link"
              style={{ cursor: "pointer" }}
            >
              Contato
            </span>
          </li>
          <li className="nav-item" onClick={handleNavCollapse}>
            <a href={LINK_TO_LOGIN} className="nav-link">
              Login
            </a>
          </li>
        </ul>
        <form className="form-inline d-none d-xl-block">
          <div
            className="btn-toolbar"
            role="toolbar"
            aria-label="Toolbar with button groups"
          >
            <a
              href={`https://api.whatsapp.com/send?phone=+${PRONTLIFE_WHATSAPP_NUMBER}&text=Olá, quero conhecer melhor o ProntLife.`}
              className="btn bg-white font-weight-bold text-primary rounded-pill my-2 mx-3 my-sm-0"
              type="button"
              tabIndex={6}
              onClick={() => sendAnalyticEventWhatsapp()}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>
                <FontAwesomeIcon
                  fixedWidth
                  size="lg"
                  icon={["fab", "whatsapp"]}
                ></FontAwesomeIcon>
              </span>
              WhatsApp
            </a>
            {/* <a
              href="https://app.prontlife.com.br/prontlife-web/login.html"
              className="btn bg-white font-weight-bold text-primary rounded-pill my-2 my-sm-0"
              type="button"
              tabIndex={6}
            >
              <span>
                <FontAwesomeIcon
                  fixedWidth
                  size="1x"
                  icon={faUserAlt}
                ></FontAwesomeIcon>
              </span>
              Login
            </a> */}
          </div>
        </form>
      </div>
    </nav>
  );
};
